import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M10.68 4.75a1.25 1.25 0 0 0-.956.444L8.672 6.44a2.75 2.75 0 0 1-2.101.977H5c-.69 0-1.25.56-1.25 1.25V18c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V8.667c0-.69-.56-1.25-1.25-1.25h-1.437a2.75 2.75 0 0 1-2.28-1.212l-.61-.904a1.25 1.25 0 0 0-1.036-.551h-2.958Zm-2.102-.523a2.75 2.75 0 0 1 2.101-.977h2.958a2.75 2.75 0 0 1 2.28 1.211l.61.905c.232.344.62.55 1.036.55H19a2.75 2.75 0 0 1 2.75 2.75V18A2.75 2.75 0 0 1 19 20.75H5A2.75 2.75 0 0 1 2.25 18V8.667A2.75 2.75 0 0 1 5 5.917h1.57c.369 0 .719-.163.956-.444l1.052-1.246Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M12 10.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM8.25 13a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorCamera;
